var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('download-excel',{attrs:{"data":_vm.usersFilledAssessments}},[_vm._v("Download Data")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }